<template>
    <div class="fullscreen-overlay">
        <div class="modal-container">
            <div class="expert-form">
                <div class="expert-form-header">
                    <h1>Request Expert Review</h1>
                </div>
                <div class="expert-form-body">
                    <div class="modal-section">
                        <div class="modal-section-column">
                            <div class="modal-section-column-row">
                                <p class="modal-section-column-label">Reviewer:&nbsp;</p>
                                <p class="modal-section-column-content">{{ formData.firstname }} {{ formData.lastname }}</p>
                            </div>
                            <div class="modal-section-column-row">
                                <p class="modal-section-column-label">Email:&nbsp;</p>
                                <p class="modal-section-column-content">{{ formData.email }}</p>
                            </div>
                        </div>
                        <div class="modal-section-column">
                            <div class="modal-section-column-row">
                                <p class="modal-section-column-label">Site:&nbsp;</p>
                                <p class="modal-section-column-content">{{ formData.site }}</p>
                            </div>
                            <div class="modal-section-column-row">
                                <p class="modal-section-column-label">Unit:&nbsp;</p>
                                <p class="modal-section-column-content">{{ formData.unit }}</p>
                            </div>
                            <div class="modal-section-column-row">
                                <p class="modal-section-column-label">Date &amp; Time:&nbsp;</p>
                                <p class="modal-section-column-content">{{ formData.datetime }}</p>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="modal-section">
                        <div class="expert-free-text-area">
                            <textarea v-model="formData.comments" class="textbox-multiline" rows="5" placeholder="Additional comments..."></textarea>
                        </div>
                    </div>
                </div>
                <div class="expert-form-footer">
                    <button class="item-button" @click="$emit('close')">Close</button>
                    <button class="item-button" @click="$emit('submit', formData)">Submit</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { ref } from "vue";
export default {
    name: "RequestExpertModal",
    emits: ["close", "submit"],
    props: {
        profile: {
            type: Object,
            required: true,
        },
        site: {
            type: String,
            required: true,
        },
        unit: {
            type: String,
            required: true,
        },
        datetime: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const tokenParsed = props.profile.keycloak?.tokenParsed || {};
        const formData = ref({
            firstname: tokenParsed.given_name || '',
            lastname: tokenParsed.family_name || '',
            email: tokenParsed.email || '',
            site: props.site,
            unit: props.unit,
            datetime: props.datetime,
            comments: '',
        });

        return { formData };
    },
};
</script>

<style scoped>
.expert-form {
    min-width: 70%;
}

.expert-form-header {
    flex: 1;
    padding: 0;
}

.expert-form-body {
    flex: 1;
}

.expert-form-footer {
    flex: 1;
    padding: 0;
}

.expert-free-text-area {
    flex: 1 1;
    padding: var(--spacing-lg);
}
</style>
